import React from "react";

/**
 * EventImagesGrid Component
 * 
 * Displays a grid of event images with dropdown menu functionality
 * 
 * @param {Object} props - Component props
 * @param {Array} props.images - Array of image objects
 * @param {Function} props.handleImageClick - Function to handle image click
 * @param {string|null} props.openMenuId - ID of currently open menu
 * @param {Function} props.setOpenMenuId - Function to set open menu ID
 * @param {Function} props.handleDeleteImage - Function to handle image deletion
 * @param {React.RefObject} props.menuRef - Reference to menu container
 * @param {React.RefObject} props.buttonRef - Reference to menu button
 * 
 * @returns {JSX.Element} Event images grid UI
 */
const EventImagesGrid = ({ 
  images, 
  handleImageClick, 
  openMenuId, 
  setOpenMenuId, 
  handleDeleteImage, 
  menuRef, 
  buttonRef 
}) => {
  return (
    <div className="event-images-grid">
      {images.map((image, index) => (
        <div
          key={image.id}
          className="event-image-card"
          onClick={() => handleImageClick(index)}
        >
          {/* 3-dot menu */}
          <button
            ref={buttonRef}
            className="image-menu-btn"
            type="button"
            aria-label={`Options for photo ${index + 1}`}
            aria-expanded={openMenuId === image.id}
            onClick={(e) => {
              e.stopPropagation();
              setOpenMenuId(openMenuId === image.id ? null : image.id);
            }}
          >
            ⋯
          </button>

          {/* Dropdown */}
          {openMenuId === image.id && (
            <div ref={menuRef} className="image-menu-dropdown">
              <button
                className="delete-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteImage(image.id);
                  setOpenMenuId(null);
                }}
              >
                Delete
              </button>
            </div>
          )}

          {/* Image */}
          <button type="button" className="event-image-bg" aria-label={`View photo ${index + 1}`}>
            <img src={image.image_url} alt="" loading="lazy" />
          </button>

          {/* <div className="event-image-name">Arun</div> */}
        </div>
      ))}
    </div>
  );
};

export default EventImagesGrid;
